import { Logger } from '@rhim/logging';
import { isDefined } from '@rhim/utils';
import { InitOptions, TFunction } from 'i18next';
import Backend from 'i18next-chained-backend';
import { merge } from 'lodash-es';
import { initReactI18next, useTranslation } from 'react-i18next';

import { I18nJsonStrategy } from './I18nJsonStrategy';

export { Trans } from 'react-i18next';

const log = new Logger({ context: 'i18nJsonReactStrategy' });

class I18nJsonReactStrategy extends I18nJsonStrategy {
  useTranslation = useTranslation;

  initialize(initOptions?: InitOptions): Promise<TFunction> {
    if (isDefined(this.initialized)) {
      log.warn('i18nJsonReactStrategy already initialized. Ignoring re-initialization.');
      return this.initialized;
    }
    const mergedOptions = merge({}, this.options, initOptions);
    this.initialized = this.i18next
      .use(Backend)
      .use(initReactI18next)
      .init(mergedOptions, (error?: Error) => {
        if (isDefined(error)) {
          log.error(error);
        }
      });

    return this.initialized;
  }

  getLocaleFromStorage = (): string | undefined => {
    const localization = localStorage.getItem('localization');
    if (isDefined(localization)) {
      try {
        const parsed = JSON.parse(localization);
        return parsed?.data?.locale;
      } catch (e) {
        log.error('Failed to parse localization from localStorage', e);
      }
    }
    return undefined;
  };
}

export const i18nReact = new I18nJsonReactStrategy();
